import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  play () {
    this.element.play()
  }
  stop () {
    this.element.pause()
  }
}
